import type { JSX } from 'react';
import type { ParticipantSearchRow } from '../../../types/events.ts';
import { List } from '@fastnorth/kraken/components/layout';
import ParticipantSearchItem from './ParticipantSearchItem.tsx';
import { useApp } from '../../../hooks/AppProvider.tsx';

type ExactMatchResultsProps = {
  rows: ParticipantSearchRow[];
};

const ExactMatchResults = ({ rows }: ExactMatchResultsProps): JSX.Element => {
  const [, dispatch] = useApp();
  return (
    <List direction="vertical" gap="4">
      {rows.map((participant) => (
        <ParticipantSearchItem
          closeSearch={() => dispatch({ type: 'setSearchSheetState', payload: false })}
          key={`participant-${participant.id}`}
          participant={participant}
          resultSubEventId={participant.resultSubEventId}
        />
      ))}
    </List>
  );
};

export default ExactMatchResults;
